import {
  createThreePointRequest,
  CreateThreePointRequestType,
  deleteThreePointRequest,
  fetchThreePointsRequest,
} from 'api';
import { setAuthLoading, setNotification, setThreePoints } from 'state/actions';
import { TypedDispatch } from 'state/types';

export const fetchThreePoints = (fileId?: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await fetchThreePointsRequest({ fileId });

    dispatch(setThreePoints(response?.data.rows));
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const createPoint =
  (data: CreateThreePointRequestType) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await createThreePointRequest(data);

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const deletePoint = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await deleteThreePointRequest(id);

    dispatch(setNotification(response?.data?.message));

    return response?.status;
  } finally {
    dispatch(setAuthLoading(false));
  }
};
